import React from 'react'
import { useTranslation } from 'react-i18next'

import { useColumnToggle } from '../../../../hooks/useColumnToggle'
import { ConfigurableTable, convertOrder } from '../../../../utils/wrapper'
import { useAllInvoices } from '../../../invoice/data'
import { useConfigContext } from '../../../ui-config/context'

const TOGGLEABLE_FIELDS = [
  'Payload.OrderDate',
  'Payload.ConfirmationId',
  'Payload.ConfirmationDate',
  'Payload.DeliveryNoteNumber',
  'Payload.DeliveryNoteDate',
  'Payload.DeliveryType',
]

const STORAGE_KEY = 'orders-invoice-visible-columns'

type Props = {
  globalFilterValue: string
  setGlobalFilterValue: (value: string) => void
  isVisible: boolean
}

export const InvoiceTable: React.FC<Props> = ({
  globalFilterValue,
  setGlobalFilterValue,
  isVisible,
}) => {
  const { t } = useTranslation()

  const { data: invoices, isLoading } = useAllInvoices()
  const { uiConfig: config } = useConfigContext()

  const tableConfig = config.orders.invoice.table
  const { effectiveTableConfig, navigationColumnHeader } = useColumnToggle(
    tableConfig,
    TOGGLEABLE_FIELDS,
    STORAGE_KEY,
  )

  return (
    <div
      hidden={!isVisible && (invoices === undefined || invoices.length === 0)}
    >
      {config.orders.invoice.enabled !== false && (
        <div className="mt-6">
          <h3>{t('orders.invoice.title')}</h3>

          <ConfigurableTable
            config={effectiveTableConfig}
            data={convertOrder(invoices)}
            link="orders/invoice"
            globalFilterValue={globalFilterValue}
            globalFilterFields={['Payload.OrderId']}
            setGlobalFilterValue={setGlobalFilterValue}
            isLoading={isLoading}
            stateKey="table-invoices"
            navigationColumnHeader={navigationColumnHeader}
          />
        </div>
      )}
    </div>
  )
}
